import { render, staticRenderFns } from "./tuikuanK copy.vue?vue&type=template&id=40902a1c&scoped=true&"
import script from "./tuikuanK copy.vue?vue&type=script&lang=js&"
export * from "./tuikuanK copy.vue?vue&type=script&lang=js&"
import style0 from "./tuikuanK copy.vue?vue&type=style&index=0&id=40902a1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40902a1c",
  null
  
)

export default component.exports